import { PropsWithChildren } from 'react'
import { Container } from 'routes/components/Layout'
import { BookCalendlyLink } from 'routes/components/Shared'
import classes from './FooterCTA.module.scss'

export const FooterCTA = ({ children }: PropsWithChildren) => {
  return (
    <section className={classes.section}>
      <Container>
        <div className={classes.wrapper}>
          <h2 className={classes.title}>
            Build every single integration your customers need with AI
          </h2>
          {children ? (
            <>{children}</>
          ) : (
            <BookCalendlyLink className={classes.button} type={'primary'}>
              Talk to an expert
            </BookCalendlyLink>
          )}
        </div>
      </Container>
    </section>
  )
}
